import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import privacyText from "assets/files/privacy.txt";

export default function Privacy() {
    const [text, setText] = useState("");

    useEffect(() => {
        fetch(privacyText)
            .then((res) => res.text())
            .then((data) => setText(data));
    }, []);

    return (
        <div className={styles.wrapper}>
            <pre className={styles.textBox}>{text}</pre>
        </div>
    );
}
